import { ApiClient } from '@/services/apiClient';
import { getEnvVariable } from '@/utils/get-env-variable';

export const pciApiClient = new ApiClient(getEnvVariable('VITE_PCI_API_URL', 'https://ext-stg-api.appchargestore.com'));
